import React, { useEffect, useRef } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { store, history } from './store';
import Theme from './contexts/theme';
import ViewsContainer from './commons/ViewsContainer';
import { useTranslation } from 'react-i18next';
import { checkCookie } from './services/CookieManager';

const ZOHO_WIDGET_CODE =
	'e9c1afc18a61b4907dc79c8e92a81322e511e3ee104a415f1782c62b0c621b23db54a7de40d19f6b3c37f8cea73c0e97';
const ZOHO_CHAT_ENABLED = false;

const App = () => {
	const { i18n } = useTranslation();
	const langRef = useRef(i18n.language);

	useEffect(() => {
		langRef.current = i18n.language;
	}, [i18n.language]);

	const initZoho = lang => {
		window.$zoho = window.$zoho || {};
		window.$zoho.salesiq = window.$zoho.salesiq || {
			widgetcode: ZOHO_WIDGET_CODE,
			values: {},
			ready: function () {
				try {
					window.$zoho.salesiq.language(lang);
				} catch (e) {}
			}
		};

		if (!document.getElementById('zsiqscript')) {
			const d = document;
			const s = d.createElement('script');
			s.type = 'text/javascript';
			s.id = 'zsiqscript';
			s.defer = true;
			s.src = 'https://salesiq.zoho.eu/widget';
			const t = d.getElementsByTagName('script')[0];
			t.parentNode.insertBefore(s, t);
		} else {
			try {
				window.$zoho.salesiq.language(lang);
			} catch (e) {}
		}
	};

	useEffect(() => {
		if (!ZOHO_CHAT_ENABLED) return undefined;

		const hasAccepted = checkCookie('accepted') === 'true';
		if (hasAccepted) initZoho(langRef.current);

		const onCookiesAccepted = () => initZoho(langRef.current);
		window.addEventListener('cookiesAccepted', onCookiesAccepted);

		return () => window.removeEventListener('cookiesAccepted', onCookiesAccepted);
	}, []);

	useEffect(() => {
		if (!ZOHO_CHAT_ENABLED) return;

		try {
			if (window.$zoho?.salesiq?.language) {
				window.$zoho.salesiq.language(i18n.language);
			}
		} catch (e) {}
	}, [i18n.language]);

	return (
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<Theme>
					<ViewsContainer />
				</Theme>
			</ConnectedRouter>
		</Provider>
	);
};

export default App;
